/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { memo } from 'react';

import Card from 'bundles/unified-seo-content-common/components/browse/Card';
import CardSection, { CARD_SECTION_TYPE } from 'bundles/unified-seo-content-common/components/browse/CardSection';
import PartnerLogo from 'bundles/unified-seo-content-common/components/browse/PartnerLogo';
import {
  PRODUCT_CARD_HEIGHT,
  PRODUCT_CARD_HEIGHT_MOBILE,
  PRODUCT_CARD_WIDTH,
} from 'bundles/unified-seo-content-common/components/browse/constants';
import {
  type PropsFromWithMediaMaxWidthScreenTablet,
  withMediaMaxWidthScreenTablet,
} from 'bundles/unified-seo-content-common/components/browse/utils';

const style = css`
  .rc-BrowseProductCard,
  &.rc-BrowseProductCard {
    min-width: 268px;
    margin-right: 20px;
    display: inline-block;
    position: relative;

    &:last-child {
      margin: 0;
    }

    .collection-product-card {
      background: transparent;

      &:focus {
        outline-offset: 3px;
        outline: 5px solid var(--cds-color-blue-200);
        outline: 5px auto -webkit-focus-ring-color;
      }
    }

    .partner-name {
      line-height: 18px;
    }

    .coursera-plus-pill {
      margin: 12px 0;
    }

    ${/* Save/Unsave Experiment */ ''}
    .rc-Bookmark {
      position: absolute;
      bottom: 16px;
      right: 20px;
    }
  }
`;

type ProductCardPlaceholderProps = {
  size?: string;
};

export const ProductCardPlaceholder = memo(({ size = 'lg' }: ProductCardPlaceholderProps) => {
  return (
    <div className="rc-ProductCard placeholder" data-size={size}>
      <Card>
        <CardSection className="productCard-cardImageContainer" type={CARD_SECTION_TYPE.IMAGE}>
          <span className="productCard-shimmer productCard-cardImage" />
        </CardSection>

        <PartnerLogo className="productCard-PartnerLogo" htmlAttributes={{ 'data-is-rtl': false }} />
        <CardSection className="productCard-titleSection">
          <div className="productCard-title productCard-shimmer" />
          <div className="productCard-subtitle productCard-shimmer" />
        </CardSection>

        <CardSection className="productCard-cardActions">
          <div className="productCard-numberOfCourses productCard-shimmer" />
        </CardSection>
      </Card>
    </div>
  );
});

type InputProps = {
  shouldUseBareComponent?: boolean;
};
type PlaceholderProps = InputProps & PropsFromWithMediaMaxWidthScreenTablet;

/** @deprecated replaced by the new ProductCardV2, do not use this component at all cost */
export const BrowseProductCardPlaceholderRender: React.FC<PlaceholderProps> = memo(
  ({ matches, shouldUseBareComponent }) => {
    return matches ? (
      <div
        className="rc-BrowseProductCard"
        data-testid="browse-product-card-placeholder"
        style={{ position: 'relative', width: PRODUCT_CARD_WIDTH, height: PRODUCT_CARD_HEIGHT_MOBILE }}
        {...(shouldUseBareComponent ? {} : { css: style })}
      >
        <ProductCardPlaceholder size="sm" />
      </div>
    ) : (
      <div
        className="rc-BrowseProductCard"
        data-testid="browse-product-card-placeholder"
        style={{ position: 'relative', width: PRODUCT_CARD_WIDTH, height: PRODUCT_CARD_HEIGHT }}
      >
        <ProductCardPlaceholder />
      </div>
    );
  }
);

const BrowseProductCardPlaceholder = withMediaMaxWidthScreenTablet(BrowseProductCardPlaceholderRender);

/** @deprecated replaced by the new ProductCardV2, do not use this component at all cost */
export default BrowseProductCardPlaceholder;
